var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.service)?_c('span',[_c('SIcon',{staticClass:"mr-1",attrs:{"name":_vm.serviceSlug,"width":15,"height":18}}),_vm._v(" "+_vm._s(_vm.serviceName)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }